import * as actionTypes from "application/redux/applicationActionTypes";

export const errorOccurred = error => ({
  type: actionTypes.ERROR_OCCURRED,
  error,
});

export const mediaItemUpdated = mediaItem => ({
  type: actionTypes.MEDIA_ITEM_UPDATED,
  mediaItem,
});

export const routeChanged = path => ({ type: actionTypes.ROUTE_CHANGED, path });
